/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SecretAlreadyExistsErrorResponseContent
 */
export interface SecretAlreadyExistsErrorResponseContent {
    /**
     * An error message
     * @type {string}
     * @memberof SecretAlreadyExistsErrorResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the SecretAlreadyExistsErrorResponseContent interface.
 */
export function instanceOfSecretAlreadyExistsErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function SecretAlreadyExistsErrorResponseContentFromJSON(json: any): SecretAlreadyExistsErrorResponseContent {
    return SecretAlreadyExistsErrorResponseContentFromJSONTyped(json, false);
}

export function SecretAlreadyExistsErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecretAlreadyExistsErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function SecretAlreadyExistsErrorResponseContentToJSON(value?: SecretAlreadyExistsErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

